/**
 * AI Fire API
 * API to access AI Fire sensor data
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import ErrorResponse from '../model/ErrorResponse';
import FireDepartment from '../model/FireDepartment';
import FireDepartmentUpdate from '../model/FireDepartmentUpdate';
import Message from '../model/Message';

/**
* FireDepartments service.
* @module api/FireDepartmentsApi
* @version 1.1.0
*/
export default class FireDepartmentsApi {

    /**
    * Constructs a new FireDepartmentsApi. 
    * @alias module:api/FireDepartmentsApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the addFireDepartment operation.
     * @callback module:api/FireDepartmentsApi~addFireDepartmentCallback
     * @param {String} error Error message, if any.
     * @param {module:model/FireDepartment} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Create new fire department
     * @param {module:model/FireDepartment} fireDepartment Fire department data for creating a new fire department
     * @param {module:api/FireDepartmentsApi~addFireDepartmentCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/FireDepartment}
     */
    addFireDepartment(fireDepartment, callback) {
      let postBody = fireDepartment;
      // verify the required parameter 'fireDepartment' is set
      if (fireDepartment === undefined || fireDepartment === null) {
        throw new Error("Missing the required parameter 'fireDepartment' when calling addFireDepartment");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['BearerAuth'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = FireDepartment;
      return this.apiClient.callApi(
        '/fire-departments', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteFireDepartment operation.
     * @callback module:api/FireDepartmentsApi~deleteFireDepartmentCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Message} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Delete fire department
     * @param {String} fireDeptId The unique identifier of the fire department
     * @param {module:api/FireDepartmentsApi~deleteFireDepartmentCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/Message}
     */
    deleteFireDepartment(fireDeptId, callback) {
      let postBody = null;
      // verify the required parameter 'fireDeptId' is set
      if (fireDeptId === undefined || fireDeptId === null) {
        throw new Error("Missing the required parameter 'fireDeptId' when calling deleteFireDepartment");
      }

      let pathParams = {
        'fireDeptId': fireDeptId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['BearerAuth'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = Message;
      return this.apiClient.callApi(
        '/fire-departments/{fireDeptId}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getAllFireDepartments operation.
     * @callback module:api/FireDepartmentsApi~getAllFireDepartmentsCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/FireDepartment>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get all fire departments
     * @param {module:api/FireDepartmentsApi~getAllFireDepartmentsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/FireDepartment>}
     */
    getAllFireDepartments(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['BearerAuth'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [FireDepartment];
      return this.apiClient.callApi(
        '/fire-departments', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getFireDepartment operation.
     * @callback module:api/FireDepartmentsApi~getFireDepartmentCallback
     * @param {String} error Error message, if any.
     * @param {module:model/FireDepartment} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get fire department by ID
     * @param {String} fireDeptId The unique identifier of the fire department
     * @param {module:api/FireDepartmentsApi~getFireDepartmentCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/FireDepartment}
     */
    getFireDepartment(fireDeptId, callback) {
      let postBody = null;
      // verify the required parameter 'fireDeptId' is set
      if (fireDeptId === undefined || fireDeptId === null) {
        throw new Error("Missing the required parameter 'fireDeptId' when calling getFireDepartment");
      }

      let pathParams = {
        'fireDeptId': fireDeptId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['BearerAuth'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = FireDepartment;
      return this.apiClient.callApi(
        '/fire-departments/{fireDeptId}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateFireDepartment operation.
     * @callback module:api/FireDepartmentsApi~updateFireDepartmentCallback
     * @param {String} error Error message, if any.
     * @param {module:model/FireDepartment} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update fire department (partial)
     * @param {String} fireDeptId The unique identifier of the fire department
     * @param {module:model/FireDepartmentUpdate} fireDepartmentUpdate Partial fire department data to update. Only provided fields will be modified.
     * @param {module:api/FireDepartmentsApi~updateFireDepartmentCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/FireDepartment}
     */
    updateFireDepartment(fireDeptId, fireDepartmentUpdate, callback) {
      let postBody = fireDepartmentUpdate;
      // verify the required parameter 'fireDeptId' is set
      if (fireDeptId === undefined || fireDeptId === null) {
        throw new Error("Missing the required parameter 'fireDeptId' when calling updateFireDepartment");
      }
      // verify the required parameter 'fireDepartmentUpdate' is set
      if (fireDepartmentUpdate === undefined || fireDepartmentUpdate === null) {
        throw new Error("Missing the required parameter 'fireDepartmentUpdate' when calling updateFireDepartment");
      }

      let pathParams = {
        'fireDeptId': fireDeptId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['BearerAuth'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = FireDepartment;
      return this.apiClient.callApi(
        '/fire-departments/{fireDeptId}', 'PATCH',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
